"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DenomToggle = DenomToggle;
exports.updateBet = updateBet;
exports.updateFormattedBet = updateFormattedBet;
var _types = require("./types");
/** Toggle denom up once, if highest it starts over on lowest */
function DenomToggle() {
  return {
    type: _types.DENOM_TOGGLE
  };
}
function updateBet(bet) {
  return {
    type: _types.UPDATE_BET,
    payload: bet
  };
}
function updateFormattedBet(formattedBet) {
  return {
    type: _types.UPDATE_FORMATTED_BET,
    payload: formattedBet
  };
}
//# sourceMappingURL=actions.js.map